import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const activitiesAPI = {
  getAll: (filters, pagination) => {
    // pagination = { limit, offset } → Server liefert dann {items, total, ...}
    // statt der flachen Liste.
    return api.get("/activities", { params: { ...filters, ...pagination } });
  },
  getById: (id) => api.get(`/activities/${id}`),
  getPdfUrl: (id) => `${API_BASE_URL}/activities/${id}/pdf`,
  getTravelPlan: (id, params, config = {}) =>
    api.get(`/activities/${id}/travel`, { params, ...config }),
  importOpeningHours: (id) =>
    api.post(`/activities/${id}/opening-hours/import`),
  importOpeningHoursFromWebsite: (name, address, website) =>
    api.post("/activities/opening-hours/import-from-website", {
      name,
      address,
      website,
    }),
  create: (data) => {
    // Wenn data ein FormData-Objekt ist, setze den richtigen Content-Type
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return api.post("/activities", data, config);
  },
  update: (id, data) => {
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return api.put(`/activities/${id}`, data, config);
  },
  delete: (id) => api.delete(`/activities/${id}`),
  archive: (id) => api.put(`/activities/${id}`, { status: "archived" }),
};

export const authAPI = {
  login: (credentials) => api.post("/auth/login", credentials),
  register: (userData) => api.post("/auth/register", userData),
  logout: () => api.post("/auth/logout"),
  getCurrentUser: () => api.get("/auth/me"),
  verifyEmail: (token) => api.get(`/auth/verify-email?token=${token}`),
  resendVerification: (email) =>
    api.post("/auth/resend-verification", { email }),
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }),
  resetPassword: (token, new_password) =>
    api.post("/auth/reset-password", { token, new_password }),
  // Stand einer vom Provider (Facebook) angestossenen Löschanfrage
  dataDeletionStatus: (code) =>
    api.get("/auth/oauth/facebook/data-deletion/status", { params: { code } }),
};

export const usersAPI = {
  updateSettings: (data) => api.put("/users/me/settings", data),
  changePassword: (data) => api.put("/users/me/password", data),
  deleteAccount: (data) => api.delete("/users/me", { data }),
  geocode: (address) => api.get("/users/geocode", { params: { address } }),
};

